export default function convertTimeZoneOffsetToString(timeZoneOffset: number): string {
    const sign = timeZoneOffset < 0 ? '-' : '+'
    const hours = Math.floor(Math.abs(timeZoneOffset) / 60)
        .toString()
        .padStart(2, '0')
    const minutes = (Math.abs(timeZoneOffset) % 60).toString().padStart(2, '0')
    return `${sign}${hours}:${minutes}`
}
